<p-blockUI [target]="target" [blocked]="blocked">
    <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
</p-blockUI>